import React from 'react';
import Hint from '../Hint';
import Input from '../Input';
import { propsWithBsClassName } from '../../utils';
const TypeaheadInputSingle = ({ inputRef, referenceElementRef, ...props }) => (React.createElement(Hint, null,
    React.createElement(Input, { ...propsWithBsClassName(props), ref: (node) => {
            inputRef(node);
            referenceElementRef(node);
        } })));
export default TypeaheadInputSingle;
